export default "__VITE_ASSET__610df07c__"